import {
  Alert,
  Box,
  Grid,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material"

import {
  ACTOR_META,
  CACHE_PITFALLS,
  DATA_CACHES,
  PROMPT_CACHE_LIMITS,
  PROMPT_CACHE_ORDER,
  PROMPT_CACHE_WINS
} from "./guideContent"
import { BulletList, Card, GuideSection } from "./guideParts"

const AGENT_COLOR = ACTOR_META.agent.color
const HOST_COLOR = ACTOR_META.host.color

function PromptOrder() {
  return (
    <Stack spacing={1}>
      {PROMPT_CACHE_ORDER.map((part, index) => (
        <Box
          key={part.title}
          sx={{
            p: 1.5,
            borderRadius: 1.5,
            border: 1,
            borderColor: "divider",
            bgcolor: `${AGENT_COLOR}${["1F", "12", "08"][index]}`
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 800 }}>
            {part.title}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {part.body}
          </Typography>
        </Box>
      ))}
    </Stack>
  )
}

export default function CacheSection() {
  return (
    <GuideSection
      id="cache"
      eyebrow="Hız ve maliyet"
      title="Önbellekler: nerede, ne kadar süre?"
      lead="v2 iki tür önbellek kullanır. Birincisi OpenAI'ın prompt önbelleği: isteğin başı daha önce gönderilmiş bir istekle aynıysa o kısım yeniden işlenmez ve onda bir fiyatına faturalanır. İkincisi qpien-ai'nin Redis'te tuttuğu veri önbellekleri: her turda veritabanına ve dış servislere gitmeyi önler."
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 900, mb: 1.5 }}>
        Prompt önbelleği (OpenAI)
      </Typography>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12} md={5}>
          <Card accent={AGENT_COLOR}>
            <Typography variant="subtitle2" sx={{ fontWeight: 900, mb: 0.5 }}>
              Talimatın sırası bu yüzden önemli
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "text.secondary", mb: 1.5 }}
            >
              Önbellek otomatik çalışır, kodda açıp kapatan bir ayar yoktur.
              Kodun yaptığı, isteğin başını mümkün olduğunca sabit tutmaktır.
            </Typography>
            <PromptOrder />
          </Card>
        </Grid>
        <Grid item xs={12} md={7}>
          <Stack spacing={2} sx={{ height: "100%" }}>
            <Card accent="#0F9D58">
              <Typography variant="subtitle2" sx={{ fontWeight: 900, mb: 1 }}>
                Nerede kazandırır?
              </Typography>
              <BulletList items={PROMPT_CACHE_WINS} />
            </Card>
            <Card accent={HOST_COLOR}>
              <Typography variant="subtitle2" sx={{ fontWeight: 900, mb: 1 }}>
                Ne bozar?
              </Typography>
              <BulletList items={PROMPT_CACHE_LIMITS} />
            </Card>
          </Stack>
        </Grid>
      </Grid>
      <Alert severity="info" sx={{ mb: 4 }}>
        Ölçüm: her model çağrısı AI Logs’ta <code>AGENT_MODEL_CALL</code>{" "}
        adımında <code>usage.cachedToken</code> taşır; turun toplamı{" "}
        <code>AGENT_OUTPUT</code> adımındadır. İsabet oranı bu değerin{" "}
        <code>inputToken</code>’a oranıdır.
      </Alert>

      <Typography variant="subtitle1" sx={{ fontWeight: 900, mb: 1.5 }}>
        Redis önbellekleri
      </Typography>
      <TableContainer
        component={Paper}
        variant="outlined"
        sx={{ borderRadius: 2, mb: 2 }}
      >
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 900 }}>Önbellek</TableCell>
              <TableCell sx={{ fontWeight: 900 }}>Süre</TableCell>
              <TableCell sx={{ fontWeight: 900 }}>Nasıl tazelenir</TableCell>
              <TableCell sx={{ fontWeight: 900 }}>Ne kazandırır</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {DATA_CACHES.map((cache) => (
              <TableRow key={cache.name}>
                <TableCell sx={{ fontWeight: 800 }}>{cache.name}</TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }}>
                  {cache.lifetime}
                </TableCell>
                <TableCell sx={{ color: "text.secondary" }}>
                  {cache.refresh}
                </TableCell>
                <TableCell>{cache.saves}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Alert severity="warning">
        <Typography variant="body2" sx={{ fontWeight: 800, mb: 0.5 }}>
          Bilinmesi gerekenler
        </Typography>
        <BulletList items={CACHE_PITFALLS} />
      </Alert>
    </GuideSection>
  )
}
